import { render } from "./Member_winnerRecord.vue?vue&type=template&id=101f7d66"
import script from "./Member_winnerRecord.vue?vue&type=script&lang=js"
export * from "./Member_winnerRecord.vue?vue&type=script&lang=js"
script.render = render

export default script